import React, { useState, useEffect } from 'react';
import { Box, TextField, Select, MenuItem, InputLabel, FormControl, IconButton, Snackbar, Alert, Button, Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableRow, TableHead } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import Navbar from '../Navbar/Navbar';
import { useCarrito } from '../context/CarritoContext';
import { useMediaQuery } from '@mui/material';
import { useMemo } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Cookies from 'js-cookie';
import { Switch, FormControlLabel } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PaidIcon from '@mui/icons-material/Paid';
import * as XLSX from 'xlsx';
import DownloadIcon from '@mui/icons-material/Download';
import dayjs from 'dayjs';



const Inventario = () => {
  const fechaActual = dayjs();
  const { rol } = useCarrito();
  const [rows, setRows] = useState([]);
  const [sucursalesPermitidas, setSucursalesPermitidas] = useState([]);
  const isMobile = useMediaQuery('(max-width:900px)');
  const mapa_sucursales = {
    "CEDIS GUADALAJARA": 1,
    "BODEGA CALVILLO": 2,
    "BODEGA DURANGO": 3,
    "BODEGA RINCON": 4,
    "SUC GALERIAS": 5,
    "SUC GDL LOPEZ MATEOS": 6,
    "SUC GDL MARIANO OTERO": 7,
    "SUC GUADALAJARA": 8,
    "SUC GUADALUPE": 9,
    "SUC LEON": 10,
    "SUC MATRIZ": 11,
    "SUC NORTE": 12,
    "SUC ORIENTE": 13,
    "SUC PASEOS": 14,
    "SUC PUERTO VALLARTA": 15,
    "SUC SUR": 16,
    "SUC ZACATECAS": 17
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [detalleInventario, setDetalleInventario] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const OtrasMarcas = Cookies.get('OtrasMarcas');
  const VerSucursales = Cookies.get('VerSucursales');
  const IdUsuario = Cookies.get('IdUsuario');
  const PrecioHankook = Cookies.get('PrecioHankook');
  const ClaEnlaceMichelin = localStorage.getItem('ClaEnlaceMichelin');
  const VerCampanaExtras = Cookies.get('CampanaExtras');
  const Zona = Cookies.get('Facturacion');
  const [soloDisponibles, setSoloDisponibles] = useState(false);
  const [campana, setCampana] = useState(false);
  const [modalMayoreoOpen, setModalMayoreoOpen] = useState(false);
  const [productoMayoreo, setProductoMayoreo] = useState(null);
  const [mto, setMto] = useState(null);
  const [modalNegarOpen, setModalNegarOpen] = useState(false);
  const [productoANegar, setProductoANegar] = useState(null);
  const [cantidadNegada, setCantidadNegada] = useState(1);
  const [modalCampanaOpen, setModalCampanaOpen] = useState(false);
  const [productoCampana, setProductoCampana] = useState(null);
  const [modalCampanaXLagoOpen, setModalCampanaXLagoOpen] = useState(false);
  const [productoCampanaXLago, setProductoCampanaXLago] = useState(null);
  const [modalPreciosListaOpen, setModalPreciosListaOpen] = useState(false);
  const [productoPreciosLista, setProductoPreciosLista] = useState(null);
  const rutaTarjeta = localStorage.getItem('Tarjeta');
  const [clienteProdNegado, setClienteProdNegado] = useState('');
  const [campanaXLago, setCampanaXLago] = useState(false);
  const campanaXLagoMSPN = [
    "19836", "30539", "05485", "01665", "63019", "91993", "56039", "94668", "75445", "28855", "85528", "95011", "36185", "65681", "83708", "65230", "98415", "01235", "36986", "21974", "15358", "90190"
  ];
  const campanaXLagoUniroyalMSPN = [
    '02406', '44847', '93470', '89654', '31724', '64935', '67118', '83997', '18728', '31514', '40065', '24461', '00648', '24129', '06238', '33585', '54052', '73566', '58787', '48403', '03300', '70183', '04325', '75509', '04585', '31359', '25054', '20031', '29011', '05925', '34031', '83587', '26922', '25794', '77050', '72775', '06902', '32927', '06986', '58107', '82963', '67862', '54780', '00722', '62415', '01571', '07841', '34215', '04287', '66186', '80398', '14316', '96020', '04731', '23796', '52787', '64333', '24371', '94976', '03816', '03183', '31800', '15950', '55296', '57140', '08531', '99457', '28508', '91200',
  ];
  const [campanaXLagoUniroyal, setCampanaXLagoUniroyal] = useState(false);
  const [modalCampanaXLagoOpenUniroyal, setModalCampanaXLagoUniroyalOpen] = useState(false);
  const [productoCampanaXLagoUniroyal, setProductoCampanaXLagoUniroyal] = useState(null);

  async function subscribeUser() {
    const registration = await navigator.serviceWorker.ready;

    const existingSubscription = await registration.pushManager.getSubscription();

    if (existingSubscription) {
      await existingSubscription.unsubscribe();
      console.log("Suscripción antigua eliminada");
    }


    const vapidPublicKey = "BBV3C9uw9GiBZsiOjP-GVTGbQoOURbBd-1ZNhPlPc8Y0-yY9JxykpOHqgdYa8KtjhOMbQUlnUlSvzIewCYBr5tM";

    const applicationServerKey = vapidPublicKey;

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey
    });

    console.log("Nueva suscripción creada:", subscription);
    const suscirpcion = [subscription, Zona]
    console.log(suscirpcion)

    // 5️⃣ Enviar al backend para guardarla
    await fetch("https://www.bibliotecadlago.com/php/save-subscription.php", {
      method: "POST",
      body: JSON.stringify({
        Subscription: subscription,
        Zona: Zona,
      }),
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  async function requestNotificationPermission() {
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      console.log("Permiso concedido");
      await subscribeUser();
    } else {
      console.log("Permiso denegado");
    }
  }

  const [filters, setFilters] = useState({
    marca: '',
    ancho: '',
    alto: '',
    rin: '',
    MSPN: '',
    sucursalId: '',
    gama: '',
  });

  const [alerta, setAlerta] = useState({
    open: false,
    mensaje: '',
    tipo: 'success',
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleAbrirCampana = (producto) => {
    setProductoCampana(producto);
    setModalCampanaOpen(true);
  };

  const handleAbrirCampanaXLago = async (producto) => {
    try {
      const response = await fetch('https://bibliotecadlago.com/php/precioMayoreo.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mspn: producto.MSPN }),
      });

      const result = await response.json();

      if (result.success && Array.isArray(result.data) && result.data.length > 0) {
        setProductoPreciosLista(result.data[0]);
      } else {
        setAlerta({
          open: true,
          mensaje: 'No se encontraron precios para este producto.',
          tipo: 'info',
        });
      }
    } catch (error) {
      console.error('Error al obtener precios lista:', error);
      setAlerta({
        open: true,
        mensaje: 'Error al consultar precios.',
        tipo: 'error',
      });
    }
    setProductoCampanaXLago(producto);
    setModalCampanaXLagoOpen(true);
  };

  const handleAbrirCampanaXLagoUniroyal = async (producto) => {
    try {
      const response = await fetch('https://bibliotecadlago.com/php/precioMayoreo.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mspn: producto.MSPN }),
      });

      const result = await response.json();

      if (result.success && Array.isArray(result.data) && result.data.length > 0) {
        setProductoPreciosLista(result.data[0]);
      } else {
        setAlerta({
          open: true,
          mensaje: 'No se encontraron precios para este producto.',
          tipo: 'info',
        });
      }
    } catch (error) {
      console.error('Error al obtener precios lista:', error);
      setAlerta({
        open: true,
        mensaje: 'Error al consultar precios.',
        tipo: 'error',
      });
    }
    setProductoCampanaXLagoUniroyal(producto);
    setModalCampanaXLagoUniroyalOpen(true);
  };

  const { agregarAlCarrito } = useCarrito();

  const copiarAlPortapapeles = (texto) => {
    navigator.clipboard.writeText(texto).then(() => {
      setAlerta({
        open: true,
        mensaje: 'Copiado al portapapeles',
        tipo: 'success',
      });
    }).catch((err) => {
      setAlerta({
        open: true,
        mensaje: 'Error al copiar',
        tipo: 'error',
      });
      console.error('Error al copiar al portapapeles: ', err);
    });
    console.log(PrecioHankook)
  };

  const fetchPreciosMayoreo = async (mspn) => {
    try {
      const response = await fetch('https://bibliotecadlago.com/php/mto.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mspn }),
      });

      const result = await response.json();

      if (result.success && Array.isArray(result.data) && result.data.length > 0) {
        const precios = result.data[0];
        setProductoMayoreo({ ...precios });
        setModalMayoreoOpen(true);
      } else {
        setAlerta({
          open: true,
          mensaje: 'No se encontraron precios mayoreo para este producto.',
          tipo: 'info',
        });
      }
    } catch (error) {
      console.error('Error al obtener precios mayoreo:', error);
      setAlerta({
        open: true,
        mensaje: 'Error al consultar precios mayoreo.',
        tipo: 'error',
      });
    }
  };

  const [marcasDisponibles, setMarcasDisponibles] = useState([]);

  const handleNegarProducto = (producto) => {
    setProductoANegar(producto);
    setCantidadNegada(1);
    setClienteProdNegado('');
    setModalNegarOpen(true);
  };


  useEffect(() => {
    const cargarInventario = () => {
      let url = 'https://bibliotecadlago.com/php/inventario.php';
      if (OtrasMarcas === 1 || OtrasMarcas === '1') {
        url = 'https://bibliotecadlago.com/php/otramarcav2.php';
      }
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ idUsuario: parseInt(IdUsuario, 10) })
      })
        .then(res => res.json())
        .then(data => {
          if (data.success && Array.isArray(data.data)) {
            const productosConId = data.data.map((item, index) => ({
              ...item,
              id: index + 1
            }));
            setRows(productosConId);
            // Extraer marcas disponibles de los productos
            const marcasDisponibles = [
              ...new Set(productosConId.map(producto => producto.marca)) // Usamos Set para eliminar duplicados
            ];
            setMarcasDisponibles(marcasDisponibles); // Guardamos las marcas disponibles
          } else {
            console.error("Respuesta inválida de la API");
          }
        })
        .catch(err => {
          console.error("Error al obtener inventario:", err);
        });
    };

    const cargarSucursalesPermitidas = () => {
      if (!IdUsuario) return;

      fetch('https://bibliotecadlago.com/php/sucursales.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ idUsuario: parseInt(IdUsuario, 10) })
      })
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data.SucursalesPermitidas)) {
            setSucursalesPermitidas(data.SucursalesPermitidas);
          } else {
            console.error("No se pudieron obtener sucursales permitidas");
          }
        })
        .catch(err => {
          console.error("Error al obtener sucursales permitidas:", err);
        });
    };

    cargarSucursalesPermitidas();
    cargarInventario();

    const intervalo = setInterval(() => {
      cargarInventario();
    }, 600000); // 600000 ms = 10 minutos

    return () => clearInterval(intervalo);

  }, [OtrasMarcas, IdUsuario]);

  useEffect(() => {
    console.log(productoCampanaXLago);
    console.log(VerCampanaExtras);
  }, [productoCampanaXLago, VerCampanaExtras])
  const sucursalSeleccionadaNombre = Object.entries(mapa_sucursales).find(([nombre, id]) => id === Number(filters.sucursalId))?.[0];

  const confirmarNegacion = async () => {
    if (!cantidadNegada || cantidadNegada <= 0 || !Number.isInteger(Number(cantidadNegada))) {
      setAlerta({
        open: true,
        mensaje: 'Ingresa una cantidad válida (entero positivo).',
        tipo: 'warning',
      });
      return;
    }
    if (rol !== "Cliente" && !clienteProdNegado.trim()) {
      alert("Debes capturar el cliente que solicita las llantas");
      return;
    }
    var tipo
    if (productoANegar.existencias > 0) {
      tipo = 'No Disponible en Zona'
    } else {
      tipo = 'Producto Negado'
    }
    try {
      const response = await fetch('https://bibliotecadlago.com/php/negar_productov2.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          MSPN: productoANegar.MSPN,
          idUsuario: parseInt(IdUsuario, 10),
          cantidad: parseInt(cantidadNegada, 10),
          cliente: clienteProdNegado,
          Tipo: tipo,
          existencia: productoANegar.existencias

        })
      });

      const data = await response.json();

      if (data.success) {
        setAlerta({
          open: true,
          mensaje: `Producto ${productoANegar.MSPN} negado con cantidad: ${cantidadNegada}`,
          tipo: 'success',
        });
      } else {
        throw new Error(data.message || 'Error al negar producto');
      }
    } catch (error) {
      console.error('Error al negar producto:', error);
      setAlerta({
        open: true,
        mensaje: 'Hubo un error al marcar como negado.',
        tipo: 'error',
      });
    }

    setModalNegarOpen(false);
  };

  const filteredRows = rows.filter((row) => {
    const existeEnSucursal =
      !filters.sucursalId ||
      (row.inventario_detalle && row.inventario_detalle.some(detalle =>
        detalle.sucursal === sucursalSeleccionadaNombre && detalle.cantidad > 0
      ));

    return (
      (!filters.marca || row.marca === filters.marca) &&
      (!filters.ancho || row.ancho.toString() === filters.ancho) &&
      (!filters.alto || row.alto.toString() === filters.alto) &&
      (!filters.rin || row.rin.toString() === filters.rin) &&
      (!filters.MSPN || row.MSPN.toLowerCase().includes(filters.MSPN.toLowerCase())) &&
      (!soloDisponibles || Number(row.existencias) > 0) &&
      (!campana || row.descuento.toString() === 'campana') &&
      (!mto || row.mto === 1) &&
      (!filters.gama || row.gama === filters.gama) &&
      (!campanaXLago || campanaXLagoMSPN.includes(row.MSPN)) &&
      (!campanaXLagoUniroyal || campanaXLagoUniroyalMSPN.includes(row.MSPN)) &&
      existeEnSucursal
    );
  });

  const columns = useMemo(() => {
    const handleAgregarAlCarrito = (producto) => {
      agregarAlCarrito(producto);
      setAlerta({
        open: true,
        mensaje: `Agregado ${producto.descripcion} al carrito`,
        tipo: 'success',
      });
    };
    return [
      {
        field: 'MSPN',
        headerName: 'MSPN',
        width: isMobile ? 80 : 80,
        renderCell: (params) => {
          const estatus = params.row.estatus;
          const descuento = params.row.descuento;
          const originalValue = params.value?.toString() || '';
          const halfLength = Math.floor(originalValue.length / 2);

          // Color por defecto
          let defaultColor = '#000';

          if (estatus === 'ACTIVO') {
            defaultColor = '#242c59';
          } else if (estatus === 'DESCONTINUADO') {
            defaultColor = '#ff6600';
          }

          // Si es campaña, colorear mitad en verde
          if ((VerCampanaExtras === 0 || VerCampanaExtras === '0') && descuento === 'campana' && dayjs(fechaActual).isBefore(dayjs(params.row.vigencia).add(1, 'day'))) {
            const firstHalf = originalValue.slice(0, halfLength);
            const secondHalf = originalValue.slice(halfLength);

            return (
              <span style={{ fontWeight: 'bold' }}>
                <span style={{ color: '#4caf50' }}>{firstHalf}</span>
                <span style={{ color: defaultColor }}>{secondHalf}</span>
              </span>
            );
          }

          // Si no es campaña, color único
          return (
            <span style={{ color: defaultColor, fontWeight: 'bold' }}>
              {originalValue}
            </span>
          );
        }
      },
      {
        field: 'descripcion',
        headerName: 'Descripción',
        width: isMobile ? 475 : 475,
        renderCell: (params) => {
          const descripcion = params.row.descripcion;
          const mspn = params.row.MSPN;
          const precio = Number(params.row.precio).toLocaleString('es-MX', {
            style: 'currency',
            currency: 'MXN',
          });

          const textoACopiar = `MSPN: ${mspn}\n Descripción: ${descripcion}\nPrecio: ${precio}`;

          return (
            <Box display="flex" alignItems="center">
              <span style={{ marginRight: 8 }}>{descripcion}</span>
              <IconButton
                onClick={() => copiarAlPortapapeles(textoACopiar)}
                size="small"
                sx={{ color: '#9c27b0' }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          );
        }
      },

      !isMobile && { field: 'ancho', headerName: 'Ancho', width: 70 },
      !isMobile && { field: 'alto', headerName: 'Alto', width: 60 },
      !isMobile && { field: 'rin', headerName: 'Rin', width: 60 },
      {
        field: 'Lista',
        headerName: 'Precio Lista',
        width: isMobile ? 100 : 120,
        renderCell: (params) => {
          const valorNumerico = Number(params.value);
          return (
            <Box
              onClick={() => handleAbrirPreciosLista(params.row)}
              sx={{
                cursor: 'pointer',
                color: '#d32f2f',
                fontWeight: 'bold',
              }}
            >
              ${valorNumerico.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </Box>
          );
        }
      },
      {
        field: 'VentaMayoreo',
        headerName: 'Precio Mayoreo',
        width: isMobile ? 100 : 120,
        renderCell: (params) => {
          var valorNumerico = Number(params.value);
          return (
            <Box
              onClick={() => handleAbrirPreciosLista(params.row)}
              sx={{
                cursor: 'pointer',
                color: '#d32f2f',
                fontWeight: 'bold',
              }}
            >
              ${valorNumerico.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </Box>
          );
        }
      },


      {
        field: 'existencias',
        headerName: 'Existencias',
        width: isMobile ? 80 : 100,
        renderCell: (params) => {
          const detalle = params.row.inventario_detalle || [];

          let cantidad = 0;

          // Si hay sucursal seleccionada → mostrar solo esa
          if (filters.sucursalId) {
            cantidad =
              detalle.find(item => item.sucursal === sucursalSeleccionadaNombre)?.cantidad || 0;
          }
          // Si NO hay sucursal seleccionada pero hay sucursalesPermitidas
          else if (sucursalesPermitidas.length > 0) {
            cantidad = detalle
              .filter(item => sucursalesPermitidas.includes(item.sucursal))
              .reduce((acc, item) => acc + Number(item.cantidad || 0), 0);
          }
          // Si no tiene restricción → mostrar total normal
          else {
            cantidad = Number(params.row.existencias);
          }

          return <span>{cantidad}</span>;
        }
      },

      {
        field: 'mayoreo',
        headerName: 'MTO',
        width: 50,
        renderCell: (params) => {
          if (params.row.mto === '1' || params.row.mto === 1) {
            return (
              <IconButton
                onClick={() => handleAbrirModalMayoreo(params.row)}
                sx={{ color: '#c401ffff' }}
              >
                <PaidIcon />
              </IconButton>
            );
          }
          return null;
        }
      },

      {
        field: 'agregar',
        headerName: '',
        width: isMobile ? 250 : 250,
        renderCell: (params) => (
          <>
            <IconButton
              onClick={() => handleAgregarAlCarrito(params.row)}
              sx={{ color: '#cf1316' }}
              disabled={params.row.existencias === 0}
            >
              <AddIcon />
            </IconButton>
            <IconButton
              onClick={() => handleAbrirModal(params.row)}
              sx={{ color: '#1976d2' }}
            >
              <InfoIcon />
            </IconButton>
            {(VerCampanaExtras === 0 || VerCampanaExtras === '0') && campanaXLagoMSPN.includes(params.row.MSPN) &&
              dayjs(fechaActual).isBefore(dayjs('2026-04-30').add(1, 'day')) && (
                <IconButton
                  onClick={() => handleAbrirCampanaXLago(params.row)}
                  sx={{ color: '#002499', ml: 1 }}
                >
                  <PaidIcon />
                </IconButton>
              )}
            {(VerCampanaExtras === 0 || VerCampanaExtras === '0') && campanaXLagoUniroyalMSPN.includes(params.row.MSPN) &&
              dayjs(fechaActual).isBefore(dayjs('2026-04-30').add(1, 'day')) && (
                <IconButton
                  onClick={() => handleAbrirCampanaXLagoUniroyal(params.row)}
                  sx={{ color: '#eff302', ml: 1 }}
                >
                  <PaidIcon />
                </IconButton>
              )}
            {(VerCampanaExtras === 0 || VerCampanaExtras === '0') && (params.row.descuento === 'campana' && dayjs(fechaActual).isBefore(dayjs(params.row.vigencia).add(1, 'day'))) && (
              <IconButton
                onClick={() => handleAbrirCampana(params.row)}
                sx={{ color: '#4caf50', ml: 1 }}
              >
                <PaidIcon />
              </IconButton>
            )}
            {(params.row.estatus !== 'DESCONTINUADO') && (
              <IconButton
                onClick={() => handleNegarProducto(params.row)}
                sx={{ color: '#ff1744', ml: 1 }}
              >
                <BlockIcon />
              </IconButton>
            )}

          </>

        ),
      },

    ].filter(Boolean); // quita los campos falsos si es móvil
  }, [isMobile, agregarAlCarrito, handleNegarProducto,]);

  const handleAbrirModal = (producto) => {
    setProductoSeleccionado(producto);
    setDetalleInventario(producto.inventario_detalle || []);
    setModalOpen(true);
  };

  const sucursalesAMostrar = VerSucursales === '0'
    ? Object.entries(mapa_sucursales).filter(([nombre, id]) =>
      sucursalesPermitidas.includes(nombre)
    )
    : Object.entries(mapa_sucursales);

  const handleAbrirModalMayoreo = (producto) => {
    fetchPreciosMayoreo(producto.MSPN);
  };

  const handleAbrirPreciosLista = async (producto) => {
    try {
      const response = await fetch('https://bibliotecadlago.com/php/precioMayoreo.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mspn: producto.MSPN }),
      });

      const result = await response.json();

      if (result.success && Array.isArray(result.data) && result.data.length > 0) {
        setProductoPreciosLista(result.data[0]);
        setModalPreciosListaOpen(true);
      } else {
        setAlerta({
          open: true,
          mensaje: 'No se encontraron precios para este producto.',
          tipo: 'info',
        });
      }
    } catch (error) {
      console.error('Error al obtener precios lista:', error);
      setAlerta({
        open: true,
        mensaje: 'Error al consultar precios.',
        tipo: 'error',
      });
    }
  };

  const gamasDisponibles = useMemo(() => {
    if (!filters.marca) {
      return [...new Set(rows.map(row => row.gama).filter(Boolean))];
    }
    return [...new Set(
      rows
        .filter(row => row.marca === filters.marca)
        .map(row => row.gama)
        .filter(Boolean)
    )];
  }, [filters.marca, rows]);


  useEffect(() => {
    if (filters.gama && !gamasDisponibles.includes(filters.gama)) {
      setFilters(prev => ({ ...prev, gama: '' }));
    }
  }, [filters.marca, gamasDisponibles]);

  const mostrarPrecioHankook = productoPreciosLista?.marca?.toUpperCase() === 'HANKOOK' && PrecioHankook;

  const labelMap = {
    Lista: 'Precio de Lista',
    VentaMayoreo: 'Lista Venta Mayoreo',
    Mayoreo: 'Precio Mayoreo',
    Especial1: 'Especial 1',
    Especial2: 'Especial 2',
    Especial3: 'Especial 3',
    Especial4: 'Especial 4',
    ColumnaA: 'Columna A',
    ColumnaB: 'Columna B',
    ColumnaC: 'Columna C',
    PrecioBase: 'Columna Precio Base',
  };

  const filasPrecios = mostrarPrecioHankook
    ? [
      ['Lista', productoPreciosLista?.Lista],
      [PrecioHankook, productoPreciosLista?.[PrecioHankook]],
    ]
    : Object.keys(labelMap).map((key) => [key, productoPreciosLista?.[key]]);


  const exportToExcel = async () => {
    try {
      const response = await fetch('https://bibliotecadlago.com/php/FormatoExcel.php');
      const data = await response.json();
      if (data.success) {

        let inventarioExcel = data.data.map(item => ({
          ...item,
          PrecioLista: (item.PrecioLista === 0 || item.PrecioLista === '' || item.PrecioLista == null)
            ? 'No Disponible'
            : item.PrecioLista,
          mto: (item.mto === 0 || item.mto === '' || item.mto == null)
            ? ''
            : 'Participa'
        }));

        if (VerSucursales === 0 || VerSucursales === '0') {
          console.log(sucursalesPermitidas)

          inventarioExcel = inventarioExcel.filter(inv =>
            sucursalesPermitidas.includes(inv.sucursal)
          );
        }

        const pivot = {};

        inventarioExcel.forEach(item => {

          const key = item.MSPN + '_' + item.descripcion;

          if (!pivot[key]) {
            pivot[key] = {
              MSPN: item.MSPN,
              descripcion: item.descripcion,
              PrecioLista: item.PrecioLista,
              estatus: item.estatus,
              mto: item.mto
            };
          }

          pivot[key][item.sucursal] = item.Cantidad;

        });

        const resultado = Object.values(pivot);

        const worksheet = XLSX.utils.json_to_sheet(resultado);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, 'InventarioLago');
        XLSX.writeFile(workbook, 'InventarioLago.xlsx');

      }
    } catch (error) {
      console.error('Error al recargar pedidos:', error);
    }


  };
  return (
    <>
      <Navbar />
      <Box p={2}>
        <Box display="flex" alignItems="center" alignContent="center" >
          {isMobile && rutaTarjeta &&
            <Box
              alignItems="center"
              alignContent="center"
              component="img"
              src={rutaTarjeta}
              alt="Logo"
              sx={{

                height: { xs: 120, sm: 180 },
                width: 'auto',
              }}
            />}
        </Box>
        <h2>Filtros</h2>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          mb={2}
          sx={{ position: 'relative' }}
        >
          <FormControl sx={{ width: { xs: '80%', sm: '30%' }, mb: { xs: 2, sm: 0 }, }} >
            <InputLabel>Marca</InputLabel>
            <Select
              name="marca"
              value={filters.marca}
              onChange={handleFilterChange}
              label="Marca"
            >
              <MenuItem value="">Todas</MenuItem>
              {marcasDisponibles.map((marca) => (
                <MenuItem key={marca} value={marca}>
                  {marca}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ width: { xs: '80%', sm: '30%' }, mb: { xs: 2, sm: 0 }, ml: { xs: 0, sm: 2 }, }} >
            <InputLabel>Gama</InputLabel>
            <Select
              name="gama"
              value={filters.gama}
              onChange={handleFilterChange}
              label="Gama"
            >
              <MenuItem value="">Todas</MenuItem>
              {gamasDisponibles.map((gama, index) => (
                <MenuItem key={index} value={gama}>{gama}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {!isMobile && rutaTarjeta && (
            <Box
              component="img"
              src={rutaTarjeta}
              alt="Logo"
              sx={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                height: 200,
                width: 'auto',
              }}
            />
          )}
        </Box>

        <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
          <TextField label="Ancho" name="ancho" value={filters.ancho} onChange={handleFilterChange} />
          <TextField label="Alto" name="alto" value={filters.alto} onChange={handleFilterChange} />
          <TextField label="Rin" name="rin" value={filters.rin} onChange={handleFilterChange} />
        </Box>

        <Box
          display="flex"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          <TextField
            label="MSPN"
            name="MSPN"
            value={filters.MSPN}
            onChange={handleFilterChange}
            width={'100%'}
            sx={{ mb: 3 }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={soloDisponibles}
                onChange={(e) => setSoloDisponibles(e.target.checked)}
              />
            }
            label="Solo disponibles"
            sx={{ ml: 2 }}
          />
          {(VerCampanaExtras === 0 || VerCampanaExtras === '0') && (
            <FormControlLabel
              control={
                <Switch
                  checked={campana}
                  onChange={(e) => setCampana(e.target.checked)}
                />
              }
              label="Campaña"
              sx={{ ml: 2 }}
            />
          )}
          <FormControlLabel
            control={
              <Switch
                checked={mto}
                onChange={(e) => setMto(e.target.checked)}
              />
            }
            label="MTO"
            sx={{ ml: 2 }}
          />
          {(VerCampanaExtras === 0 || VerCampanaExtras === '0') && dayjs(fechaActual).isBefore(dayjs('2026-05-01')) && (
            <>
              <FormControlLabel
                control={
                  <Switch
                    checked={campanaXLago}
                    onChange={(e) => setCampanaXLago(e.target.checked)}
                  />
                }
                label="Campaña XLago"
                sx={{ ml: 2 }}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={campanaXLagoUniroyal}
                    onChange={(e) => setCampanaXLagoUniroyal(e.target.checked)}
                  />
                }
                label="Campaña XLago Unirutal"
                sx={{ ml: 2 }}
              />
            </>
          )}
          {!isMobile && (
            <Box sx={{ ml: 2 }}>
              <p style={{ fontSize: '14px', color: '#555', fontStyle: 'italic', margin: 0 }}>
                Todos los precios mostrados son antes de IVA
              </p>
            </Box>
          )}
        </Box>
        <FormControl sx={{ width: '80%', mb: 2 }}>
          <InputLabel>Sucursal</InputLabel>
          <Select
            name="sucursalId"
            value={filters.sucursalId}
            onChange={handleFilterChange}
            label="Sucursal"
          >
            <MenuItem value="">Todas</MenuItem>
            {sucursalesAMostrar.map(([nombre, id]) => (
              <MenuItem key={id} value={id}>{nombre}</MenuItem>
            ))}
          </Select>
        </FormControl>


        <Box display="flex" alignItems="center" gap={2} mb={2} mt={1} flexWrap="wrap">
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, backgroundColor: '#242c59', borderRadius: '4px' }} />
            <span>Activo</span>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, backgroundColor: '#ff6600', borderRadius: '4px' }} />
            <span>Fuera de gama</span>
          </Box>
          {(VerCampanaExtras === 0 || VerCampanaExtras === '0') && (
            <>
              <Box display="flex" alignItems="center" gap={1}>
                <Box sx={{ width: 20, height: 20, backgroundColor: '#4caf50', borderRadius: '4px' }} />
                <span>Campaña</span>
              </Box>
              {(VerCampanaExtras === 0 || VerCampanaExtras === '0') && dayjs(fechaActual).isBefore(dayjs('2026-05-01')) && (
                <>
                  <Box display="flex" alignItems="center" gap={1}>
                    <PaidIcon sx={{ color: '#002499', ml: 1 }} />
                    <span>Campaña XLago</span>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <PaidIcon sx={{ color: '#eff302', ml: 1 }} />
                    <span>Campaña XLago Uniroyal</span>
                  </Box>
                </>
              )}
            </>
          )}

          {(rol !== 'Cliente' || ClaEnlaceMichelin === 'BIB+' || ClaEnlaceMichelin === 'ORO') && (
            <Button variant="contained" color="primary" onClick={exportToExcel}
              sx={{
                backgroundColor: '#242c59',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#1b2247',
                },
                mb: 2
              }}>
              <DownloadIcon />
            </Button>
          )}

        </Box>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <BlockIcon sx={{ color: '#ff1744' }} />
          <span style={{ fontSize: '14px' }}>
            Si no hay existencia, marcalo como <strong>negado</strong> para solicitar más.
          </span>
          {rol !== 'Cliente' && (
            <Button
              variant="contained"
              size="small"
              onClick={requestNotificationPermission}
              sx={{ ml: "auto", textTransform: "none" }}
            >
              Activar notificaciones
            </Button>
          )}

        </Box>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          {isMobile && <p style={{ fontSize: '16px', color: '#555', fontStyle: 'italic' }}> Todos los precios mostrados son antes de IVA </p>}
        </Box>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          autoHeight
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
        />
      </Box>

      <Snackbar
        open={alerta.open}
        autoHideDuration={1000}
        onClose={() => setAlerta({ ...alerta, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setAlerta({ ...alerta, open: false })}
          severity={alerta.tipo}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alerta.mensaje}
        </Alert>
      </Snackbar>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          Inventario por sucursal - {productoSeleccionado?.MSPN}
        </DialogTitle>
        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sucursal</TableCell>
                <TableCell>Cantidad</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detalleInventario
                .filter(item =>
                  Number(item.cantidad) > 0 &&
                  (
                    !filters.sucursalId || item.sucursal === sucursalSeleccionadaNombre
                  ) &&
                  (
                    sucursalesPermitidas.length === 0 ||
                    sucursalesPermitidas.includes(item.sucursal)
                  )
                )

                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.sucursal}</TableCell>
                    <TableCell>{item.cantidad}</TableCell>
                  </TableRow>
                ))}
              {VerSucursales === '0' && detalleInventario.some(item =>
                Number(item.cantidad) > 0 &&
                !sucursalesPermitidas.includes(item.sucursal)
              ) && (
                  <TableRow>
                    <TableCell colSpan={2} style={{ color: '#888', fontStyle: 'italic' }}>
                      Existen unidades en otras sucursales consultar con el asesor asignado.
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
      <Dialog open={modalCampanaOpen} onClose={() => setModalCampanaOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          🏷️ Producto en campaña - {productoCampana?.descripcion}
        </DialogTitle>
        <DialogContent dividers>
          <p><strong>MSPN:</strong> {productoCampana?.MSPN}</p>
          <p>
            <strong>Vigencia:</strong> Del {productoCampana?.inicio ? new Date(productoCampana.inicio + 'T12:00:00').toLocaleDateString('es-ES') : 'No especificada'} al {productoCampana?.vigencia
              ? new Date(productoCampana.vigencia + 'T12:00:00').toLocaleDateString('es-ES')
              : 'No especificada'}
          </p>
          <p><strong>Precio Promocion + IVA: $</strong> {productoCampana?.porcentaje || 'No especificado'}</p>
        </DialogContent>
      </Dialog>
      <Dialog open={modalMayoreoOpen} onClose={() => setModalMayoreoOpen(false)} fullWidth maxWidth="md">
        <DialogTitle>
          Precios Mayoreo - {productoMayoreo?.MSPN}
        </DialogTitle>
        <DialogContent dividers>
          <p><strong>Descripción:</strong> {productoMayoreo?.descripcion}</p>
          <p>Todos los precios mostrados son antes de IVA</p>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>MSPN</strong></TableCell>
                <TableCell><strong>Precio MAYOREO 1-25 llantas</strong></TableCell>
                <TableCell><strong>Precio MAYOREO 26-50 llantas</strong></TableCell>
                <TableCell><strong>Precio MAYOREO 51-74 llantas</strong></TableCell>
                <TableCell><strong>Precio MAYOREO 75+ llantas</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{productoMayoreo?.MSPN}</TableCell>
                <TableCell>{productoMayoreo?.Mayoreo25 && `$${Number(productoMayoreo?.Mayoreo25).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`}</TableCell>
                <TableCell>{productoMayoreo?.Mayoreo50 && `$${Number(productoMayoreo?.Mayoreo50).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`}</TableCell>
                <TableCell>{productoMayoreo?.Mayoreo74 && `$${Number(productoMayoreo?.Mayoreo74).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`}</TableCell>
                <TableCell>{productoMayoreo?.Mayoreo && `$${Number(productoMayoreo?.Mayoreo).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
      <Dialog open={modalPreciosListaOpen} onClose={() => setModalPreciosListaOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          📋 Precios Mayoreo - {productoPreciosLista?.MSPN}
        </DialogTitle>
        <DialogContent dividers>
          <p><strong>Descripción:</strong> {productoPreciosLista?.descripcion}</p>
          <p>Todos los precios mostrados son antes de IVA</p>
          <Table>
            <TableBody>
              {filasPrecios
                .filter(([_, value]) => {
                  const num = Number(value);
                  return value !== undefined && value !== null && value !== '' && !isNaN(num) && num !== 0;
                })
                .map(([key, value], idx) => (
                  <TableRow key={idx}>
                    <TableCell><strong>{labelMap[key] || key}</strong></TableCell>
                    <TableCell>
                      {`$${Number(value).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <p>{productoPreciosLista?.Nota}</p>

          </Table>
        </DialogContent>
      </Dialog>
      <Dialog open={modalNegarOpen} onClose={() => setModalNegarOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>🚫 Producto no encontrado</DialogTitle>
        <DialogContent>
          <p><strong>MSPN:</strong> {productoANegar?.MSPN}</p>
          <p><strong>Descripción:</strong> {productoANegar?.descripcion}</p>
          <p><strong>Existencias:</strong> {productoANegar?.existencias}</p>
          {rol !== 'Cliente' && (
            <TextField
              id="clienteProdNegado"
              label="Cliente que solicita las llantas"
              fullWidth
              required
              error={!clienteProdNegado}
              helperText={!clienteProdNegado ? "Este campo es obligatorio" : ""}
              value={clienteProdNegado}
              onChange={(e) => {
                setClienteProdNegado(e.target.value);
              }}
              sx={{ mt: 2 }}
            />
          )}
          <TextField
            id='cantidadNoEncontrada'
            label="Cantidad no encontrada"
            type="number"
            fullWidth
            inputProps={{ min: 1, step: 1 }}
            value={cantidadNegada}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*$/.test(val)) {
                setCantidadNegada(val);
              }
            }}
            sx={{ mt: 2 }}
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <IconButton
              onClick={confirmarNegacion}
              color="error"
              variant="contained"
              sx={{ px: 2 }}
            >
              <BlockIcon />
              <span style={{ marginLeft: 8 }}>Solicitar</span>
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={modalCampanaXLagoOpen} onClose={() => setModalCampanaXLagoOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          🏷️ Producto en campaña XLago - {productoCampanaXLago?.descripcion}
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 3
            }}
          >
            <Box sx={{ flex: 1 }}>
              <p><strong>MSPN:</strong> {productoCampanaXLago?.MSPN}</p>

              <p>
                <strong>Vigencia:</strong> Del 06/03/2026 al 30/04/2026
              </p>

              <p>
                <strong>Precio de promoción a mitad de precio: $</strong>
                {Number(productoPreciosLista?.Lista * 0.50 || 0).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </p>


              <p>
                Nota: El precio mostrado es el descuento máximo, no se aplican descuentos adicionales.
              </p>
              <p>
                La promoción aplica únicamente cuando los productos se incluyen en la misma venta/compra.
              </p>

            </Box>
            <Box>
              <img
                src="/campanaXLago.jfif"
                alt="Campaña XLago"
                style={{ width: "150px" }}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={modalCampanaXLagoOpenUniroyal} onClose={() => setModalCampanaXLagoUniroyalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          🏷️ Producto en campaña XLago Uniroyal - {productoCampanaXLagoUniroyal?.descripcion}
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 3
            }}
          >
            <Box sx={{ flex: 1 }}>
              <p><strong>MSPN:</strong> {productoCampanaXLagoUniroyal?.MSPN}</p>

              <p>
                <strong>Vigencia:</strong> Del 06/03/2026 al 30/04/2026
              </p>

              <p>
                <strong>Precio de promoción a mitad de precio: $</strong>
                {Number(productoPreciosLista?.Lista * 0.50 || 0).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </p>
              <p>
                Nota: El precio mostrado es el descuento máximo, no se aplican descuentos adicionales.
              </p>
            </Box>
            <Box>
              <img
                src="/campanaXLago.jfif"
                alt="Campaña XLago"
                style={{ width: "150px" }}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

    </>
  );
};

export default Inventario;
